import { Injectable, OnInit, EventEmitter, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { SignalrServiceLegacy } from './signalr.service.legacy';
import { LocalizationService } from './localization.service';
import { OddModel } from '@components/sports.component';
import { UserHelper } from '@helpers/user.helper';
import { UiHelper } from '@helpers/ui.helper';
import { DataHelper } from '@helpers/data.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { DOCUMENT } from '@angular/common';
import { CashoutURL } from '@environments/environment';
import { pushToDataLayer } from '@helpers/gtm.util';
import { environment } from '@environments/environment';
@Injectable()
export class ApiService {
  constructor(
    private http: HttpClient,
    private router: Router,
    private _SignalrServiceLegacy: SignalrServiceLegacy,
    private _LocalizationService: LocalizationService,
    public _UserHelper: UserHelper,
    private _UiHelper: UiHelper,
    private _DataHelper: DataHelper,
    @Inject(DOCUMENT) document
  ) {
    this._SignalrServiceLegacy.init();
    this.getSelectedOdds();

    this._UiHelper.isActiveSignalrConnectionListener.subscribe(state => {
      this.signalrConnection(state);
    });
  }

  private url_main = '/API';
  //private url_main = '/API';
  // for prod
  private url_login = '/Login';
  //private url_login = '/Login';

  private sliderUrl = this.url_main + '/Slider';
  private highlightUrl = this.url_main + '/Highlights';
  private sidebannerUrl = this.url_main + '/SideBanner';
  private bottommenuUrl = this.url_main + '/bottommenu';
  private topmenuUrl = this.url_main + '/topmenu';
  private preMatchUrl = this.url_main + '/SportFixture';
  private sportsUrl = this.url_main + '/Sports';
  private countriesUrl = this.url_main + '/Countries';
  private TourementsByCatIDUrl = this.url_main + '/TournamentsByCategoryId';
  private OutrightsByCatIDUrl = this.url_main + '/OutrightsByCategoryId';
  private addOddUrl = this.url_main + '/PickOdd';
  private selectedOddsUrl = this.url_main + '/SelectedOdds';
  private bookingsUrl = this.url_main + '/Bookings';
  private transcationTypesUrl = this.url_main + '/TransactionTypes';
  private slipByDateUrl = this.url_main + '/Slips';
  private signInUrl = this.url_login + '/SignIn';
  private signOutUrl = this.url_login + '/SignOut';
  private getClientUrl = this.url_login + '/GetClient';
  private getClient2Url = this.url_login + '/GetClient2';
  private getForgotPasswordUrl = this.url_login + '/ForgetPassword';
  private getForgotPasswordUrl2 = this.url_login + '/ForgetPassword2';

  private changePasswordUrl = this.url_login + '/ChangePassword';
  private casinoUrl = this.url_main + '/CasinoGames';
  private slipDetailUrl = this.url_main + '/SlipDetail';
  private couponDetailBySlipIdUrl = this.url_main + '/SlipOneBySlipId';
  private fixtureUrl = this.url_main + '/FixtureMobile';
  private eventDetailUrl = this.url_main + '/MatchOddsbyGroup';
  private eventUrl = this.url_main + '/match';
  private getAccountLockUrl = this.url_main + '/AccountLockCustomer';
  private getSelfLimitsUrl = this.url_main + '/SelfLimits';
  private saveSelfLimitsUrl = this.url_main + '/SaveCustomerSelfLimits';
  private saveSelfLimitsUrl2 = this.url_main + '/SaveCustomerSelfLimits2';
  private customerRegisterUrl = this.url_main + '/CustomerRegisterSOW';

  private getCurrentSlipUrl = this.url_main + '/CurrentSlip';
  private getClearSlipUrl = this.url_main + '/ClearSlip';
  private getRemoveOddUrl = this.url_main + '/RemoveOdd';
  private getCurrentSlipAmountUrl = this.url_main + '/CurrentSlipAmount';
  private getPlaceBetUrl = this.url_main + '/PlaceBet';
  private getSearchUrl = this.url_main + '/Search';
  private getLoginRefresh = this.url_login + '/Refresh';
  private getSystemItemsUrl = this.url_main + '/SystemItems';
  private getChangeSystemSlipUrl = this.url_main + '/ChangeSystemSlip';
  private getSignUpUrl = this.url_login + '/SignUp';
  private getSignUpB3Url = this.url_login + '/SignUpB3';
  private getEmailCheck = this.url_login + '/EmailCheck';
  private getCurrencyUrl = this.url_main + '/Currency';
  private getSaluteListUrl = this.url_login + '/GetSaluteFields';
  private getSignUpFieldsUrl = this.url_login + '/GetSignUpFields';
  private getCountryUrl = this.url_main + '/ComboCountry';
  private getMoneySourceUrl = this.url_main + '/ComboMoneySource';

  private getCountryUrl2 = this.url_main + '/ComboCountry2';
  private getCountryExtentionUrl = this.url_main + '/ComboCountryExtention';

  private getTaxRateUrl = this.url_login + '/GetTaxRate';
  private getCashoutSlipsUrl = this.url_main + '/CashOutSlips';
  private getCashoutSlipDetailUrl = this.url_main + '/CashOutSlipDetail';
  private getCashoutValueUrl = this.url_main + '/CashoutDetail';
  private getCashOutPayUrl = this.url_main + '/CashOutPay';
  private getWalletListUrl = this.url_login + '/CustomerWalletList2';
  private quickRegisterUrl = this.url_login + '/Quickregister';
  private switchWalletrUrl = this.url_login + '/SwitchWallet';
  private saveAffiliationUrl = this.url_login + '/SaveAffiliation';

  private refreshCurrentSlipUrl = this.url_main + '/RefreshCurrentSlip';

  private getAllDepositControlUrl = this.url_main + '/AllDepositControl';
  private getUploadsFilesUrl = this.url_main + '/UploadsFiles';
  private getCreditCardDepositUrl = this.url_main + '/CreditCardDeposit';
  private getAllWithdrawControlUrl = this.url_main + '/AllWithdrawControl';
  private getCoinBaseDepositUrl = this.url_main + '/CoinBaseDeposit';
  private getPaymentGatewayApUrl = this.url_main + '/PaymentGatewayAp';
  private getBitcoinWithdrawUrl = this.url_main + '/BitcoinWithdraw';
  private getWithdrawBanksUrl = this.url_main + '/WithdrawBanks';
  private getBanksWithdrawUrl = this.url_main + '/BanksWithdraw';
  private getOutrightSportsUrl = this.url_main + '/OutrightSports';
  private getOutrightCategoriesUrl = this.url_main + '/OutrightCategories';
  private getOutrightEventsUrl = this.url_main + '/OutrightEvents';
  private getOutrightMatchUrl = this.url_main + '/OutrightMatch';
  private getOutrightMatchOddsUrl = this.url_main + '/OutrightMatchOdds';
  private getOutrightMatchOddsbyTourIdUrl = this.url_main + '/OutrightMatchOddsbyTourId';
  private getResultSportsUrl = this.url_main + '/ResultSports';
  private getResultCategoriesUrl = this.url_main + '/ResultCategories';
  private getTournamentsByCategoryIdUrl = this.url_main + '/TournamentsByCategoryId';
  private getResultsUrl = this.url_main + '/Results';
  private getGetCustomerTicketUrl = this.url_main + '/GetCustomerTicket';
  private getCustomerTicketDetailUrl = this.url_main + '/GetCustomerTicketDetail';
  private getAnswerTicketMessageUrl = this.url_main + '/AnswerTicketMessage';
  private getUploadtoAWSUrl = this.url_main + '/UploadtoAWS';
  private getGetCustomerOneUrl = this.url_main + '/CustomerOne';
  private getComboPhoneNumberUrl = this.url_main + '/ComboPhoneNumber';
  private getComboPasswordQuestionUrl = this.url_main + '/ComboPasswordQuestion';
  private getSaveCustomerDetailUrl = this.url_main + '/SaveCustomerDetail';
  private cashbackStatusUrl = this.url_main + '/CashbackStatus';
  private joinCashbackUrl = this.url_main + '/JoinCashback';
  private cashbackBalanceUrl = this.url_main + '/CashbackBalance';

  private getCloudFilesUrl = this.url_main + '/CloudFiles';
  private getUploaddocControl = this.url_main + '/UploadsFiles';

  private getUnreadMessageUrl = this.url_main + '/GetUnreadMessage';
  private getPagesUrl = this.url_main + '/Pages';
  private getPagebyTitleUrl = this.url_main + '/pagebytitle';
  private getMailConfirmUrl = this.url_login + '/MailConfirm';

  private getSearch4FavsUrl = this.url_main + '/Search4Favs';
  private recoverPasswordUrl = this.url_login + '/RecoveryPassword';
  private getScannerSlipDetailUrl = this.url_main + '/ScannerSlipDetail';
  private getScannerSlipOneBySlipIdUrl = this.url_main + '/ScannerSlipOneBySlipId';
  private slipRestoreUrl = this.url_main + '/SlipRestore';
  private helpMailUrl = this.url_main + '/HelpMail';

  private getPlaceBetTempUrl = this.url_main + '/PlaceBetTemp';
  private CasinoControlUrl = this.url_main + '/CasinoControl';
  private AWSGetImageUrl = this.url_main + '/AWSGetImage';

  private getUploadtoAWSFromSupportUrl = this.url_main + '/UploadtoAWSFromSupport';

  private postNotificationId = 'http://localhost:4000/save-subscription';
  private getWithDrawDepositControl3Url = this.url_main + '/WithDrawDepositControl3';

  private getAllDepositControl3Url = this.url_main + '/AllDepositControl3';
  private bookingLoginResultUrl = this.url_main + '/BookingLoginResult';

  private digitalCardUrl = this.url_main + '/GetDigitalCard';

  private procCustomerQrCodeResultUrl = this.url_main + '/ProcCustomerQrCodeResult';
  private procAccountLockReasonResultUrl = this.url_main + '/ProcAccountLockReasonResult';
  private procAccountLockDayResultUrl = this.url_main + '/ProcAccountLockDayResult';
  private procCustomerAccountLockNewResultUrl = this.url_main + '/procCustomerAccountLockNewResult';

  private getWithdrawAutoBanksUrl = this.url_main + '/WithdrawAutoBanks';
  private getWithdrawAutoMuchbetterUrl = this.url_main + '/WithdrawAutoMuchbetter';
  private getWithdrawAutoPaypalUrl = this.url_main + '/WithdrawAutoPaypal';
  private getProcCustomerWithDrawRequestScreenResultUrl = this.url_main + '/ProcCustomerWithDrawRequestScreenResult';
  private getProcCustomerBonusTrackerResultUrl = this.url_main + '/ProcCustomerBonusTrackerResult';
  private getProcCustomerBonusTracker1ResultUrl = this.url_main + '/ProcCustomerBonusTracker1Result';
  private getProcTournamentTopResultUrl = this.url_main + '/ProcTournamentTopResult';
  private getProcCustomerIBANUIDResultUrl = this.url_main + '/ProcCustomerIBANUIDResult';
  private ProcMatchStandingResult = this.url_main + '/ProcMatchStandingResult';
  private ProcCustomerContractUrl = this.url_main + '/ProcCustomerContract';

  private restoreSlipUrl = this.url_main + '/restoreSlip';
  private getQuickRegisterUrl = 'API' + '/GetQuickregister';

  private postPasswordControl = this.url_main + '/passwordControl';
  private SaveCustomerSelfLimitsWithPassword = this.url_main + '/SaveCustomerSelfLimitsWithPassword';
  private getSearchB3000Url = this.url_main + '/B3000Search';
  private getTransactionHistoryUrl = this.url_main + '/TransactionHistory';

  private antiForgeryToken = '';
  private getProcCustomerBonusOnlineTracker1ResultUrl = this.url_main + '/ProcCustomerBonusOnlineTracker1Result';
  private getResendConfirmationMailUrl = this.url_main + '/ResendConfirmationMail';

  private pay3000Url = this.url_main + '/Integration/Register';
  private revokeUrl = this.url_main + '/Integration/revoke';
  private pay3000ConfirmRegisterurl = this.url_main + '/Integration/ConfirmRegister';
  private getOddComparisonUrl = this.url_main + '/getOddComparison';
  private sliderWebUrl = this.url_main + '/SliderWeb';
  private AutoWithdrawAutoReqUrl = this.url_main + '/WithdrawAutoReq';
  private customerCashoutInfoUrl = this.url_login + '/CustomerCashoutInfo';
  private RealityCheckProviderUrl = this.url_main + '/RealityCheckProvider';
  private timeOutURL = this.url_main + '/timeOut';
  private RealityCheckPlayerUrl = this.url_main + '/RealityCheckPlayer';
  private getBranchAddressUrl = this.url_main + '/BranchAddress';
  private getProcCustomerStatusRequestResultUrl = this.url_main + '/ProcCustomerStatusRequestResult';

  // Selected Odds
  selectedOddsEvent: EventEmitter<any> = new EventEmitter();
  // selectedOdds: OddModel[] = [];

  slipCurrents = [];
  translatorPipe = new TranslatePipe(this._LocalizationService);

  flagCurrentSlipAmount = false;

  flagCashoutSlipsExternal = false;
  dataCashoutSlipsExternal;

  // refresh slip
  flag_control_refreshcurrentslip = 0;

  setAntiForgeryToken(e) {
    this.antiForgeryToken = e;
  }

  getSlider(v: string): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.sliderUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getHighlight(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.highlightUrl}/${this._LocalizationService.LANGID}/${this._LocalizationService.TIMEZONE}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getSideBanner(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.sidebannerUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        // .log(r);
        this._DataHelper.setSideBannerData(r);
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getBottomMenu(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.bottommenuUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getTopMenu(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.topmenuUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getSports(dayFilter = 24): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.sportsUrl}/${this._LocalizationService.LANGID}/${dayFilter}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getCountriesBySportsID(dayFilter = 24, _sportsID): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.countriesUrl}/${_sportsID}/${this._LocalizationService.LANGID}/${dayFilter}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getTourementsByCountryID(dayFilter = 24, _sportsID, _countriesID): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.TourementsByCatIDUrl}/${_sportsID}/${_countriesID}/${this._LocalizationService.LANGID}/${dayFilter}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getOutrightsByCountryID(dayFilter = 24, _sportsID, _countriesID): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.OutrightsByCatIDUrl}/${_sportsID}/${_countriesID}/${this._LocalizationService.LANGID}/${dayFilter}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getFixture(_sportIds = '0', _categoryIds = '0'): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    // sport filter
    let _tournamentIds = '';
    if (this._DataHelper.LeagueData != undefined && this._DataHelper.LeagueData.length > 0) {
      _sportIds = '';
      _categoryIds = '';
      _tournamentIds = '';

      this._DataHelper.LeagueData.forEach(tournament => {
        _sportIds += tournament.SportId + '|';
        _categoryIds += tournament.CategoryId + '|';
        _tournamentIds += tournament.TournamentId + '|';
      });
    } else {
      // _categoryIds = "0";
      _tournamentIds = '0';
    }
    // sport filter

    return this.http
      .get(
        `${this.fixtureUrl}/${_sportIds}/${_categoryIds}/${_tournamentIds}/${this._DataHelper.leftMenuSportDayFilter}/${this._LocalizationService.LANGID}/${this._LocalizationService.TIMEZONE}`,
        { headers }
      )
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getUpcomingFixture(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`/API/FixtureUpcoming/0/-1/0/${this._DataHelper.leftMenuSportDayFilter}/${this._LocalizationService.LANGID}/${this._LocalizationService.TIMEZONE}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getBet3000UpcomingFixture(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`/API/ProcFixtureUpcomingResult/0/-1/0/${this._DataHelper.leftMenuSportDayFilter}/${this._LocalizationService.LANGID}/${this._LocalizationService.TIMEZONE}`, {
        headers,
      })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  // [GET("API/SportFixture/{TournamentId}/{CategoryId}/{SportId}/{FixtureDate}/{LangId}/{TimeZone}")]

  /*
    updateCase(data: string, caseID: string): Promise<any> {
      const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')

      return this.http.put(this.case, JSON.stringify({content: data}), {headers})
        .toPromise()
        .then(response => {
        })
        .catch((error) => {return this.handleError(error);});
    }

    updateCaseSelective(data: any, caseID: string): Promise<any> {
      const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')

      return this.http.post(this.updateCaseSelectiveUrl, JSON.stringify({content: data}), {headers})
        .toPromise()
        .then(response => {
        })
        .catch((error) => {return this.handleError(error);});
    }


  */

  signIn(loginDataRaw: any): Promise<any> {
    if (loginDataRaw == undefined) {
      return;
    }

    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('username', loginDataRaw.userName);
    urlParams.append('password', loginDataRaw.userPassword);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    // GTM
    pushToDataLayer({ event: 'login' });

    return this.http
      .post(this.signInUrl, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);

        this.refreshAuthToken()
          .then()
          .catch(err => console.log(err));

        return responseData;
      })
      .catch(error => {
        const translator = new TranslatePipe(this._LocalizationService);
        const t_message = translator.transform('errorcode500', null);
        this._UiHelper.errorSnackBar(t_message, '');
        this.refreshAuthToken()
          .then()
          .catch(err => console.log(err));
        window.location.href = '/home';
        return '';
      });
  }

  signOut(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(this.signOutUrl, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getClient(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(this.getClientUrl)
      .toPromise()
      .then((r: any) => {
        this._UserHelper.isInsicStatus = r.IsInsic;
        this._UserHelper.IsLimitSet = r.IsLimitSet;

        ////// console.log(r);
        // initial Start
        // this.getCurrentSlip();
        return r;
      })
      .catch(e => {
        if (e.status == 401) {
          return false;
        }
      });
  }

  getClient2(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(this.getClient2Url + '/' + this._UserHelper.customerUser.CustomerId)
      .toPromise()
      .then((r: any) => {
        this._UserHelper.customerUser.Balance = r.Balance + '  ' + this._UserHelper.customerUser.Symbol;
        this._UserHelper.customerUser.BalanceAmount = r.Balance;
        this._UserHelper.customerUser.Bonus = r.Bonus;
        this._UserHelper.customerUser.IsCashOutInfo = r.IsCashOutInfo;

        return this._UserHelper.customerUser;
      })
      .catch(e => {
        if (e.status == 401) {
          // console.warn("401 ERROR");
          return false;
        }
      });
  }

  getCountryInfo(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get('/API/GetCountryInfo')
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => {
        if (e.status == 401) {
          return false;
        }
      });
  }

  getSearch(q): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    q = q.replace(' ', '+');

    return this.http
      .get(`${this.getSearchUrl}/${q}/${this._LocalizationService.LANGID}/${this._LocalizationService.TIMEZONE}`)
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getBookings(_month = 1, _year = 2019, _tid = 0): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.bookingsUrl}/${this._LocalizationService.LANGID}/${_month}/${_tid}/${_year}/${this._LocalizationService.TIMEZONE}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getTranscationsTypes(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.transcationTypesUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getWalletList(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getWalletListUrl}/${this._UserHelper.customerUser.CustomerId}`, { headers })
      .toPromise()
      .then((r: Array<any>) => {
        if (r && r.length > 0) {
          this._UserHelper.walletList = r;
          this._UserHelper.emailIsVerified = r[0].IsVerification;
          const selectedWallet = r.filter(selectedWallet => selectedWallet.CustomerId == this._UserHelper.customerUser.CustomerId);
          if (selectedWallet && selectedWallet.length > 0) {
            this._DataHelper.selectedWallet = selectedWallet[0];
          }
          this._UserHelper.LugasDialogListener.emit(true);
          this._UserHelper.ResetDialogListener.emit(true);
          return r;
        }
      })
      .catch(error => {
        // return this.handleError(error);
      });
  }

  forgotPassword(forgotPasswordDataRaw: any): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('email', forgotPasswordDataRaw.email);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getForgotPasswordUrl, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);

        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  forgotPassword2(forgotPasswordDataRaw: any): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('email', forgotPasswordDataRaw.email);
    urlParams.append('birthday', forgotPasswordDataRaw.birthDay);

    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getForgotPasswordUrl2, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);

        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getSlips(_month = 1, _year = 2019, _tid = 0): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.slipByDateUrl}/${this._LocalizationService.LANGID}/${_tid}/${this._LocalizationService.TIMEZONE}/${_month}/${_year}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        const translator = new TranslatePipe(this._LocalizationService);
        const t_message = translator.transform('errorcode5', null);
        this._UiHelper.errorSnackBar(t_message, '');
        return '';
      });
  }

  changePassword(changePasswordDatas: any): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('changeoldpassword', changePasswordDatas.oldPassword);
    urlParams.append('changenewpassword', changePasswordDatas.newPassword);
    urlParams.append('changenewrepassword', changePasswordDatas.reNewPassword);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    // this.checkOnlineStatus();
    return this.http
      .post(this.changePasswordUrl, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  addOdd(oddId): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('OddId', oddId);
    urlParams.append('BetType', '0');
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const slipstring = JSON.stringify(this.slipCurrents);
    localStorage.setItem('currentslip', slipstring);
    urlParams.append('currentslip', slipstring);
    const body = urlParams.toString();

    return this.http
      .post(this.addOddUrl, body, { headers })
      .toPromise()
      .then((response: any) => {
        this.slipCurrents = response;
        const slipstring = JSON.stringify(this.slipCurrents);
        localStorage.setItem('currentslip', slipstring);

        this.getSelectedOdds();
        // comp.getSelectedOdds();
        this.getCurrentSlip();
        return '';
      })
      .catch(error => {
        this.refreshAuthToken()
          .then()
          .catch(err => console.log(err));
        return '';
      });
  }

  sendNotificationIds(_subscription): Promise<any> {
    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.postNotificationId, { subscription: _subscription }, { headers })
      .toPromise()
      .then(response => {
        return '';
      })
      .catch(error => {
        return '';
      });
  }

  addLiveOdd(oddId): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('OddId', oddId);
    urlParams.append('BetType', '1');
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const slipstring = JSON.stringify(this.slipCurrents);
    localStorage.setItem('currentslip', slipstring);
    urlParams.append('currentslip', slipstring);
    const body = urlParams.toString();

    return this.http
      .post(this.addOddUrl, body, { headers })
      .toPromise()
      .then((response: any) => {
        this.slipCurrents = response;
        const slipstring = JSON.stringify(this.slipCurrents);
        localStorage.setItem('currentslip', slipstring);

        this.getSelectedOdds();
        // comp.getSelectedOdds();
        this.getCurrentSlip();
      })
      .catch(error => {
        this.refreshAuthToken()
          .then()
          .catch(err => console.log(err));
        return '';
      });
  }
  SelectOddBooleanValue(value: boolean): void {
    if (environment.product === 'b500') {
      this._DataHelper.isSelectOdd = false;

      setTimeout(() => {
        this._DataHelper.isSelectOdd = true;
      }, 0);
    }
  }

  addOddDirectly(newOdd): void {
    const indexOfOdd = this.slipCurrents.filter(e => e.OddId1 == newOdd.OddId1);
    this.SelectOddBooleanValue(true);

    if (indexOfOdd.length > 0) {
      this.slipCurrents = this.slipCurrents.filter(e => e.OddId1 != newOdd.OddId1);
    } else {
      this.slipCurrents.push(newOdd);
    }

    const slipstring = JSON.stringify(this.slipCurrents);
    localStorage.setItem('currentslip', slipstring);
    this.slipCurrents = JSON.parse(localStorage.getItem('currentslip'));

    this.getCurrentSlip();
  }

  addOddDirectlyWithoutNotify(newOdd): void {
    const indexOfOdd = this.slipCurrents.filter(e => e.OddId1 == newOdd.OddId1);

    if (indexOfOdd.length > 0) {
      this.slipCurrents = this.slipCurrents.filter(e => e.OddId1 != newOdd.OddId1);
    } else {
      this.slipCurrents.push(newOdd);
    }
    const slipstring = JSON.stringify(this.slipCurrents);
    localStorage.setItem('currentslip', slipstring);
    this.slipCurrents = JSON.parse(localStorage.getItem('currentslip'));
  }

  public addOddNew(odd, betType = '0', eventdata, specialBetValue, oddValue, _oddType, outcome, isLive) {
    const urlParams = new URLSearchParams();
    /*urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('OddId', odd.OddId);
    urlParams.append('BetType', betType);
    urlParams.append('LangId', this._LocalizationService.LANGID.toString());
    urlParams.append('EventName', event.HomeTeam + ' - ' + event.AwayTeam);
    urlParams.append('MatchId', event.MatchId);
    urlParams.append('OddsType', odd.GroupName.split('|')[1]);
    urlParams.append('OddsTypeId', odd.OddTypeId);
    urlParams.append('OddValue1', odd.OddValue);
    urlParams.append('OutCome', odd.OutCome);
    urlParams.append('ShortOddType', odd.ShortOddType);
    urlParams.append('SpecialBetValue', odd.SpecialBetValue !== '' ? '(' + odd.SpecialBetValue + ')' : '');
    urlParams.append('EventDate', event.EventDate);
    urlParams.append('SportName', event.SportNameOriginal);
    urlParams.append('TimeZone', this._LocalizationService.TIMEZONE.toString());*/

    const newodd = {
      OddsType: _oddType,
      SpecialBetValue: specialBetValue,
      Banko: false,
      BetType: isLive ? 1 : 0,
      Enable: true,
      EventName: eventdata.HomeTeam + '-' + eventdata.AwayTeam,
      MatchId: isLive ? eventdata.EventId : eventdata.MatchId,
      OddId1: odd,
      OddsTypeId: 1839,
      OddValue1: oddValue,
      HomeTeam: eventdata.HomeTeam,
      AwayTeam: eventdata.AwayTeam,
      OutCome: outcome,
      Visibility: '',
    };
  }

  getSelectedOdds(): Promise<OddModel[]> {
    return null;
  }

  getCasinoGames(_casinoType = 0): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.casinoUrl}/${_casinoType}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getCasinoBSGames(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`API/CasinoBSGames`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getCasinoTrustGames(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`API/CasinoTrsGames`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getCasinoOgzSlotGames(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`API/CasinoOgzSlotGames`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getCasinoGroupGA(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`API/getCasinoGroupGA`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  getGoldenRaceGameList(): Promise<any> {
    const urlParms = new URLSearchParams();
    const body = urlParms.toString();
    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(`casino/xpress/GetGameList`, body, { headers })
      .toPromise()
      .then(response => {
        const slipstring = JSON.parse(response as string);
        return slipstring;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  GoldenRaceGameLaunch(gameid): Promise<any> {
    const urlParms = new URLSearchParams();
    const body = urlParms.toString();
    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(`casino/xpress/GameLaunch/` + gameid.toString() + `/` + this._LocalizationService.LANGCODE, body, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getCasinoXPGames(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get('/API/CasinoXPGames', { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  CasinoXPGameLaunch(gameid: number, mobile: number): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`/API/CasinoXPGameLaunch/` + gameid.toString() + `/` + mobile.toString(), { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  CasinoBSGameLaunch(gameid: number, productid: number, platform: string, langcode: string): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`/API/CasinoBSGameLaunch/` + gameid.toString() + `/` + productid.toString() + `/` + platform.toString() + `/` + langcode.toString(), { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getEventDetails(_matchid = 0, _groupid = 2): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.eventDetailUrl}/${_matchid}/${this._LocalizationService.LANGID}/${_groupid}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  CasinoDSVirtualLaunch(gameid: number, mobile: number): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`/API/CasinoDSVirtualLaunch/` + gameid.toString() + `/` + mobile.toString() + `/` + this._LocalizationService.LANGCODE, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  CasinoOgzSlotLaunch(gameid: number, platform: string): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`/API/CasinoOgzSlotLaunch/` + gameid.toString() + `/` + platform.toString() + `/` + this._LocalizationService.LANGCODE, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  CasinoGroupGALaunch(gameid: number, platform: string): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`/API/CasinoGroupGALaunch/` + gameid.toString() + `/` + platform.toString() + `/` + this._LocalizationService.LANGCODE, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  CasinoVivoLaunch(gameid: number, platform: string, application: string, tableid: string): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(
        `/API/CasinoVivoLaunch/` +
          gameid.toString() +
          `/` +
          platform.toString() +
          `/` +
          this._LocalizationService.LANGCODE +
          `/` +
          application.toString() +
          `/` +
          tableid.toString(),
        { headers }
      )
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  CasinoLuckyStreakLaunch(gameid: number, application: string, tableid: string, gameType: string, limitid: string): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(
        `/API/CasinoLuckyStreakLaunch/` +
          gameid.toString() +
          `/` +
          this._LocalizationService.LANGCODE +
          `/` +
          application.toString() +
          `/` +
          tableid.toString() +
          `/` +
          gameType.toString() +
          `/` +
          limitid.toString(),
        { headers }
      )
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getEvent(_matchid = 0): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.eventUrl}/${_matchid}/${this._LocalizationService.LANGID}/${this._LocalizationService.TIMEZONE}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getSlipDetail(_slipId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.slipDetailUrl}/${this._LocalizationService.LANGID}/${_slipId}/${this._LocalizationService.TIMEZONE}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        const translator = new TranslatePipe(this._LocalizationService);
        const t_message = translator.transform('errorcode5', null);
        this._UiHelper.errorSnackBar(t_message, '');
        return '';
      });
  }

  getCouponDetailBySlipId(_slipId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.couponDetailBySlipIdUrl}/${this._LocalizationService.LANGID}/${_slipId}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return '';
      });
  }

  accountLock(accountLockDataRaw: any): Promise<any> {
    let lockDayCount = 0;
    if (accountLockDataRaw.lockDay == '') {
      lockDayCount = 9999;
    } else {
      lockDayCount = accountLockDataRaw.lockDay;
    }

    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('lockDayCount', lockDayCount.toString());
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getAccountLockUrl, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);

        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getSelfLimits(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getSelfLimitsUrl}/`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  quickRegister(quickRegisterDatas: any): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('Email', quickRegisterDatas.eMail);
    urlParams.append('BirthName', quickRegisterDatas.lastName);
    urlParams.append('IsPromotion', quickRegisterDatas.IsPromotion);
    urlParams.append('BirthPlace', quickRegisterDatas.birthPlace);
    urlParams.append('Country', quickRegisterDatas.country);

    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.quickRegisterUrl, body, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  cashoutInfo(): Promise<any> {
    const urlParams = new URLSearchParams();

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.customerCashoutInfoUrl, body, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  switchWallet(CustomerId, BranchId): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    urlParams.append('CustomerId', CustomerId);
    urlParams.append('BranchId', BranchId);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.switchWalletrUrl, body, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this._UiHelper.setLoadingDialog(false);
      });
  }

  saveSelfLimits(selfLimits: any): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('CustomerSelfLimitId', selfLimits.CustomerLimitId);
    urlParams.append('StakeDailyLimit', selfLimits.StakeDailyLimit);
    urlParams.append('StakeWeeklyLimit', selfLimits.StakeWeeklyLimit);
    urlParams.append('StakeMonthlyLimit', selfLimits.StakeMonthlyLimit);
    urlParams.append('DepositDailyLimit', selfLimits.DepositDailyLimit);
    urlParams.append('DepositWeeklyLimit', selfLimits.DepositWeeklyLimit);
    urlParams.append('DepositMonthlyLimit', selfLimits.DepositMonthlyLimit);
    urlParams.append('LossDailyLimit', selfLimits.LossDailyLimit);
    urlParams.append('LossWeeklyLimit', selfLimits.LossWeeklyLimit);
    urlParams.append('LossMonthlyLimit', selfLimits.LossMonthlyLimit);
    urlParams.append('LangId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.saveSelfLimitsUrl, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  saveSelfLimits2(LimitAmount, LimitType, TimeType): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('LimitAmount', LimitAmount);
    urlParams.append('LimitType', LimitType);
    urlParams.append('TimeType', TimeType);

    urlParams.append('LangId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.saveSelfLimitsUrl2, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  registerSow(): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post(this.customerRegisterUrl, body, options)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  saveSelfLimitsWithPassword(selfLimits: any): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('CustomerSelfLimitId', selfLimits.CustomerLimitId);
    urlParams.append('StakeDailyLimit', selfLimits.StakeDailyLimit);
    urlParams.append('StakeWeeklyLimit', selfLimits.StakeWeeklyLimit);
    urlParams.append('StakeMonthlyLimit', selfLimits.StakeMonthlyLimit);
    urlParams.append('DepositDailyLimit', selfLimits.DepositDailyLimit);
    urlParams.append('DepositWeeklyLimit', selfLimits.DepositWeeklyLimit);
    urlParams.append('DepositMonthlyLimit', selfLimits.DepositMonthlyLimit);
    urlParams.append('LossDailyLimit', selfLimits.LossDailyLimit);
    urlParams.append('LossWeeklyLimit', selfLimits.LossWeeklyLimit);
    urlParams.append('LossMonthlyLimit', selfLimits.LossMonthlyLimit);
    urlParams.append('password', selfLimits.password);
    urlParams.append('ActivityCode', selfLimits.activityCode);

    urlParams.append('LangId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.SaveCustomerSelfLimitsWithPassword, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getCurrentSlip(): Promise<any> {
    this._DataHelper.setCurrentSlipData(this.slipCurrents);
    return;
  }

  currentSlipRemoveOdd(oddId): void {
    const ixofevent = this.slipCurrents.findIndex(o => o.OddId1 == oddId);
    this.slipCurrents.splice(ixofevent, 1);
    const slipstring = JSON.stringify(this.slipCurrents);
    localStorage.setItem('currentslip', slipstring);
    this.slipCurrents = JSON.parse(localStorage.getItem('currentslip'));

    this.getSelectedOdds();
    this.getCurrentSlip();
  }

  clearCurrentSlip(): any {
    this.slipCurrents = [];
    const slipstring = JSON.stringify(this.slipCurrents);
    localStorage.setItem('currentslip', slipstring);

    this.getSelectedOdds();
    this.getCurrentSlip();

    return 1;
  }

  clearSlipSystem(): any {
    this._DataHelper.currentSlipSystemInfo = [];
    this._DataHelper.currentSlipSystemSelection = [];
  }

  getCurrentSlipAmount(amount, slipType, values = ''): any {
    // if (this.flagCurrentSlipAmount) {
    //  const promise1 = new Promise((resolve, reject) => {
    //    resolve(null);
    //  });
    //  return promise1;
    // }

    this.flagCurrentSlipAmount = true;

    let newValues = '';

    // Trigger when current Tab selected to 2, System
    if (this._UiHelper.currentSlipTabSelected == 2) {
      newValues = values;
    } else {
      newValues = '';
    }

    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('stake', amount);
    urlParams.append('sliptype', slipType);
    urlParams.append('values', newValues);

    const slipstring = JSON.stringify(this.slipCurrents);
    urlParams.append('currentslip', slipstring);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getCurrentSlipAmountUrl, body, { headers })
      .toPromise()
      .then(response => {
        this.flagCurrentSlipAmount = false;

        return response;
      })
      .catch(error => {
        this.refreshAuthToken()
          .then()
          .catch(err => console.log(err));
        return null;
      });
  }

  placeBet(amount, slipType, values): Promise<any> {
    try {
      const urlParams = new URLSearchParams();
      urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
      urlParams.append('stake', amount);
      urlParams.append('sliptype', slipType);
      urlParams.append('langId', this._LocalizationService.LANGID.toString());
      urlParams.append('langcode', this._LocalizationService.LANGCODE.toString());
      urlParams.append(
        'values',
        this._DataHelper.currentSlipSystemInfo
          .map((systemVal, index, array) => {
            return this._DataHelper.currentSlipSystemSelection.includes(`${systemVal.index + 1}_${systemVal.combination}`)
              ? `1${array.length === index + 1 ? '' : ','}`
              : `0${array.length === index + 1 ? '' : ','}`;
          })
          .join('')
      );
      if (this._DataHelper.currentSlipSystemSelection.length === 0 && this._UiHelper.currentSlipTabSelected === 2) {
        this._UiHelper.errorSnackBar(this.translatorPipe.transform('b3000_current_slip_core_text_2'), '');
        return Promise.reject(false);
      }

      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: this.antiForgeryToken,
        }),
        observe: 'response' as 'body',
        responseType: 'text' as const,
      };

      const slipstring = JSON.stringify(this.slipCurrents);
      urlParams.append('currentslip', slipstring);
      const body = urlParams.toString();

      return this.http
        .post(this.getPlaceBetUrl, body, options)
        .toPromise()
        .then(response => {
          return response;
        })
        .catch(error => {
          return this.handleError(error);
        });
    } catch (err) {
      console.log(err);
      return Promise.reject(err);
    }
  }

  placeBetTemp(amount, slipType, values): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('stake', amount);
    urlParams.append('sliptype', slipType);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('langcode', this._LocalizationService.LANGCODE.toString());
    urlParams.append(
      'values',
      this._DataHelper.currentSlipSystemInfo
        .map((systemVal, index, array) => {
          return this._DataHelper.currentSlipSystemSelection.includes(`${systemVal.index + 1}_${systemVal.combination}`)
            ? `1${array.length === index + 1 ? '' : ','}`
            : `0${array.length === index + 1 ? '' : ','}`;
        })
        .join('')
    );
    if (this._DataHelper.currentSlipSystemSelection.length === 0 && this._UiHelper.currentSlipTabSelected === 2) {
      this._UiHelper.errorSnackBar(this.translatorPipe.transform('b3000_current_slip_core_text_2'), '');
      return Promise.reject(false);
    }

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.antiForgeryToken,
      }),
      observe: 'response' as 'body',
      responseType: 'text' as const,
    };

    const slipstring = JSON.stringify(this.slipCurrents);
    urlParams.append('currentslip', slipstring);
    const body = urlParams.toString();

    return this.http
      .post(this.getPlaceBetTempUrl, body, options)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        this._UiHelper.setLoadingDialog(false);
        return this.handleError(error);
      });
  }

  userLoggedInSuccessfully(): Promise<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.antiForgeryToken,
      }),
      observe: 'response' as 'body',
      responseType: 'text' as const,
    };
    return this.http
      .get(`${this.getLoginRefresh}`, options)
      .toPromise()
      .then(result => {
        return result;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getSystemItems(): Promise<any> {
    const urlParams = new URLSearchParams();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const slipstring = JSON.stringify(this._DataHelper.currentSlipData);
    urlParams.append('currentslip', slipstring);
    const body = urlParams.toString();
    return this.http
      .post(`${this.getSystemItemsUrl}`, body, { headers })
      .toPromise()
      .then(result => {
        return result;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  checkEmailUsage(email: string): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getEmailCheck}/${email}/`, { headers })
      .toPromise()
      .then(result => {
        return result;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  changeSelectedSlipCurrent(enable, bank, oddId): any {
    const urlParams = new URLSearchParams();

    const _odd = this.slipCurrents.filter(s => s.OddId1 == oddId);

    if (_odd != undefined && _odd.length > 0) {
      _odd[0].Enable = enable;
      _odd[0].Banko = bank;
    }
    const slipstring = JSON.stringify(this.slipCurrents);
    localStorage.setItem('currentslip', slipstring);
    this.slipCurrents = JSON.parse(localStorage.getItem('currentslip'));
    this.getCurrentSlip();
    return this.slipCurrents;
  }

  signUp(data): Promise<any> {
    const birthDay = data.bday;
    let countryid = '1';
    if (data.country != undefined && data.country != '') {
      countryid = data.country;
    }

    let currencyid = '1';
    let username = data.mail;

    if (data.currency != undefined) {
      currencyid = data.currency;
    }

    if (data.username != undefined && data.username != '') {
      username = data.username;
    }

    const urlParams = new URLSearchParams();
    urlParams.append('address', data.address);
    urlParams.append('ssn', data.agreement);
    urlParams.append('branch', data.bayi);
    urlParams.append('birthday', birthDay);
    urlParams.append('birthplace', data.bplace);
    urlParams.append('idnumber', data.citizenship_number);
    urlParams.append('countryid', countryid);
    urlParams.append('currencyId', currencyid);
    urlParams.append('email', data.mail);
    urlParams.append('passportnumber', data.pass_no);
    urlParams.append('password', data.password);
    urlParams.append('repassword', data.re_password);
    urlParams.append('phone', data.phone);
    urlParams.append('taxno', data.tax_no);
    urlParams.append('promotion_permission', data.promotion_permission);
    urlParams.append('firstname', data.userFName);
    urlParams.append('lastname', data.userLName);
    urlParams.append('username', username);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('timeZone', this._LocalizationService.TIMEZONE.toString());
    urlParams.append('city', data.city);
    urlParams.append('zip', data.zip);
    urlParams.append('housenumber', data.housenumber);
    urlParams.append('phonecodeid', data.PhoneCodeId);
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getSignUpUrl, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  signUpB3(data): Promise<any> {
    const birthDay = data.bday;
    let countryid = '1';
    if (data.country != undefined && data.country != '') {
      countryid = data.country;
    }

    let currencyid = '1';
    let username = data.mail;

    if (data.currency != undefined) {
      currencyid = data.currency;
    }

    if (data.username != undefined && data.username != '') {
      username = data.username;
    }

    const urlParams = new URLSearchParams();
    urlParams.append('address', data.address);
    urlParams.append('ssn', data.agreement);
    urlParams.append('branch', data.bayi);
    urlParams.append('birthday', birthDay);
    urlParams.append('birthplace', data.bplace);
    urlParams.append('idnumber', data.citizenship_number);
    urlParams.append('countryid', countryid);
    urlParams.append('currencyId', currencyid);
    urlParams.append('email', data.mailf);
    urlParams.append('passportnumber', data.pass_no);
    urlParams.append('password', data.password);
    urlParams.append('repassword', data.re_password);
    urlParams.append('phone', data.phone);
    urlParams.append('taxno', data.tax_no);
    urlParams.append('promotion_permission', data.promotion_permission);
    urlParams.append('firstname', data.userFName);
    urlParams.append('lastname', data.userLName);
    urlParams.append('username', username);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('timeZone', this._LocalizationService.TIMEZONE.toString());
    urlParams.append('city', data.city);
    urlParams.append('zip', data.zip);
    urlParams.append('housenumber', data.housenumber);
    urlParams.append('phonecodeid', data.phonecodeid);
    urlParams.append('titleId', data.titleId);
    urlParams.append('birthName', data.birthName);
    urlParams.append('nationalty', data.nationalty);
    urlParams.append('prefferedLang', data.prefferedLang);
    urlParams.append('isBonus', data.isBonus);
    urlParams.append('GroupId', data.moneySource);

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getSignUpB3Url, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(error => {
        this._UiHelper.setLoadingDialog(false);
        const translator = new TranslatePipe(this._LocalizationService);
        const t_message = translator.transform('errorcode3', null);
        this._UiHelper.successSnackBar(t_message, '');
        return this.handleError(error);
      });
  }

  saveAffiliation(cid, iacookies): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('cid', cid);
    urlParams.append('ia_affid', iacookies.ia_affid);
    urlParams.append('btag', iacookies.btag);
    urlParams.append('siteid', iacookies.siteId);
    urlParams.append('playerid', iacookies.playerid);
    urlParams.append('timeStamp', iacookies.timeStamp);
    // ia_affid, string btag, string siteid, string playerid

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.saveAffiliationUrl, body, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  savePay3000(pay3000): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('customerAccountNumber', pay3000.value.pay3000Id);
    urlParams.append('isAccepted', pay3000.value.terms_and_condition);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.pay3000Url, body, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  revokePay3000(consentId: string): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('consentId', consentId);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.revokeUrl, body, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  confirmPay3000(consentId): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('consentId', consentId);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.pay3000ConfirmRegisterurl, body, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getCurrencyList(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getCurrencyUrl}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return '';
      });
  }

  getSaluteList(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getSaluteListUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return '';
      });
  }

  getCountryList(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.getCountryUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  getMoneySourceList(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.getMoneySourceUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  getCountryListLang(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.getCountryUrl2}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getExtentionCountryList(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.getCountryExtentionUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getSignUpFields(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getSignUpFieldsUrl}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getTaxRate(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getTaxRateUrl}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getCashoutSlips(_tid = 1): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getCashoutSlipsUrl}/${this._LocalizationService.LANGID}/${_tid}/${this._LocalizationService.TIMEZONE}`, { headers })
      .toPromise()
      .then(r => {
        this._DataHelper.setCashoutData(r);
        return r;
      })
      .catch(error => {
        const translator = new TranslatePipe(this._LocalizationService);
        const t_message = translator.transform('errorcode5', null);
        this._UiHelper.errorSnackBar(t_message, '');
        return '';
      });
  }

  getCashoutSlipsExternal(_tid = 1): Promise<any> {
    this.flagCashoutSlipsExternal = true;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const apiurl = CashoutURL + 'CashOutSlipsExternal';

    let currentcid = '1';
    if (this._UserHelper.customerUser != undefined && this._UserHelper.customerUser.CustomerId != undefined) {
      currentcid = this._UserHelper.customerUser.CustomerId;
    }
    return this.http
      .get(`${apiurl}/${currentcid}/${this._LocalizationService.LANGID}/${_tid}/${this._LocalizationService.TIMEZONE}`, { headers })
      .toPromise()
      .then(r => {
        this._DataHelper.setCashoutData(r);
        // this.dataCashoutSlipsExternal = r;
        this.flagCashoutSlipsExternal = false;
        return r;
      })
      .catch(error => {
        const translator = new TranslatePipe(this._LocalizationService);
        const t_message = translator.transform('errorcode5', null);
        this._UiHelper.errorSnackBar(t_message, '');
        this.flagCashoutSlipsExternal = false;
        return '';
      });
  }

  getCashoutSlipDetail(_slipId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getCashoutSlipDetailUrl}/${this._LocalizationService.LANGID}/${_slipId}/${this._LocalizationService.TIMEZONE}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return '';
      });
  }

  getCashoutValue(_slipId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getCashoutValueUrl}/${this._LocalizationService.LANGID}/${_slipId}/${this._LocalizationService.TIMEZONE}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return '';
      });
  }

  getCashoutValueExternal(_slipId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const apiurl = CashoutURL + 'CashoutDetailExternal';
    return this.http
      .get(
        environment.isNewCashout
          ? `${environment.newCashoutUrl}/cashoutValue?id=${_slipId}&langID=${this._LocalizationService.LANGID.toString()}`
          : `${apiurl}/${this._LocalizationService.LANGID}/${_slipId}/${this._LocalizationService.TIMEZONE}`,
        { headers }
      )
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return '';
      });
  }

  cashOutPay(_slipId, _cashOutValue): Promise<any> {
    const urlParams = new URLSearchParams();
    // CashOutValue SlipId LangId
    urlParams.append('CashOutValue', _cashOutValue);
    urlParams.append('SlipId', _slipId);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getCashOutPayUrl, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  refreshCurrentSlip(): Promise<any> {
    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    if (this.flag_control_refreshcurrentslip == 1) {
      return Promise.resolve('flag_control_refreshcurrentslip');
    }

    this.flag_control_refreshcurrentslip = 1;

    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    const slipstring = JSON.stringify(this.slipCurrents);
    localStorage.setItem('currentslip', slipstring);
    urlParams.append('currentslip', slipstring);
    const body = urlParams.toString();

    return this.http
      .post(`${this.refreshCurrentSlipUrl}/${this._LocalizationService.LANGID}`, body, { headers })
      .toPromise()
      .then((r: any) => {
        if (this._UiHelper.flagRefreshCurrentSlip) {
          this.slipCurrents = r;
          const slipstring = JSON.stringify(this.slipCurrents);
          localStorage.setItem('currentslip', slipstring);
          this.getCurrentSlip();
        }
        this.flag_control_refreshcurrentslip = 0;
        return r;
      })
      .catch(c => {
        this.flag_control_refreshcurrentslip = 0;
        return '';
      });
  }

  // refresh slip

  getAllDepositControl(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getAllDepositControlUrl}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getCasbackStatus(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.cashbackStatusUrl}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getCashbackBalance(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.cashbackBalanceUrl}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  joinCashback(): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    const body = urlParams.toString();
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(`${this.joinCashbackUrl}`, body, { headers: headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getUploadsFiles(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getUploadsFilesUrl}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  depositCreditCard(creditcardDataRaw): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('ccdepositname', creditcardDataRaw.firstName + ' ' + creditcardDataRaw.lastName);
    urlParams.append('ccdepositamount', creditcardDataRaw.amount);
    urlParams.append('ccdepositaccountno', creditcardDataRaw.cardNumber);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getCreditCardDepositUrl, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  depositPaydox(creditcardDataRaw): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('amounttext', creditcardDataRaw.amount);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('/API/PdxDeposit', body, options)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  depositPaydox2(creditcardDataRaw): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('amounttext', creditcardDataRaw.amount);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('/API/PdxDeposit2', body, options)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  depositirgate(creditcardDataRaw): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('amounttext', creditcardDataRaw.amount);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('/API/irgateDeposit', body, options)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  depositPaydoxReturn(orderid, ordercode, goapihash): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('orderid', orderid);
    urlParams.append('ordercode', ordercode);
    urlParams.append('goapihash', goapihash);
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('/API/PdxReturn', body, options)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  depositPaydox2Return(orderid, ordercode, goapihash): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('orderid', orderid);
    urlParams.append('ordercode', ordercode);
    urlParams.append('goapihash', goapihash);
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('/API/PdxReturn2', body, options)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  depositirgateReturn(order_id, transaction_id, amount): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('order_id', order_id);
    urlParams.append('transaction_id', transaction_id);
    urlParams.append('amount', amount);
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('/API/irgatereturn', body, options)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getAllWithdrawControl(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getAllWithdrawControlUrl}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  depositCoinBase(amounttext): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('amounttext', amounttext);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getCoinBaseDepositUrl, body, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  depositCoinPayments(amounttext, coinList): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('amounttext', amounttext);
    urlParams.append('coin', coinList);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.url_main + '/CoinPaymentsDeposit', body, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  depositApco(amounttext, typeid): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('Amount', amounttext);
    urlParams.append('typeid', typeid);
    urlParams.append('LangId', this._LocalizationService.LANGID.toString());
    urlParams.append('langCode', this._LocalizationService.LANGCODE.toString());

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post(this.getPaymentGatewayApUrl, body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  depositOptile(amounttext, typeid, ismobile): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('Amount', amounttext);
    urlParams.append('typeid', typeid);
    urlParams.append('LangId', this._LocalizationService.LANGID.toString());
    urlParams.append('langCode', this._LocalizationService.LANGCODE.toString());
    urlParams.append('ismobile', ismobile);

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('/API/depositOptile', body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  depositLugasControl(amounttext, typeid, ismobile): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('Amount', amounttext);
    urlParams.append('typeid', typeid);
    urlParams.append('LangId', this._LocalizationService.LANGID.toString());
    urlParams.append('langCode', this._LocalizationService.LANGCODE.toString());
    urlParams.append('ismobile', ismobile);

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('/API/DepositLugasControl', body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  depositPaylado(amounttext): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('amount', amounttext);
    // urlParams.append('typeid', typeid);
    // urlParams.append('LangId', this._LocalizationService.LANGID.toString());
    // urlParams.append('langCode', this._LocalizationService.LANGCODE.toString());
    // urlParams.append('ismobile', ismobile);

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('API/Integration/PayladoSale', body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  confirmPaylado(token): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('token', token);
    // urlParams.append('typeid', typeid);
    // urlParams.append('LangId', this._LocalizationService.LANGID.toString());
    // urlParams.append('langCode', this._LocalizationService.LANGCODE.toString());
    // urlParams.append('ismobile', ismobile);

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('API/Integration/PayladoConfirm', body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  withdrawOptile(amounttext, typeid, ismobile): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('Amount', amounttext);
    urlParams.append('typeid', typeid);
    urlParams.append('LangId', this._LocalizationService.LANGID.toString());
    urlParams.append('langCode', this._LocalizationService.LANGCODE.toString());
    urlParams.append('ismobile', ismobile);

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('/API/withdrawOptile', body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  withdrawPaylado(amounttext, typeid, ismobile): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('Amount', amounttext);
    urlParams.append('typeid', typeid);
    urlParams.append('LangId', this._LocalizationService.LANGID.toString());
    urlParams.append('langCode', this._LocalizationService.LANGCODE.toString());
    urlParams.append('ismobile', ismobile);

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('/API/withdrawPaylado', body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  DepositWithdrawArenaPay(amount, type): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('amount', amount);
    urlParams.append('type', type);
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('/API/Integration/InitiateEcommercePayment', body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  depositSkrill(amounttext, typeid): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('Amount', amounttext);
    urlParams.append('typeid', typeid);
    urlParams.append('LangId', this._LocalizationService.LANGID.toString());
    urlParams.append('langCode', this._LocalizationService.LANGCODE.toString());

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('/API/DepositSkrill', body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  depositPaysafeCard(amounttext, typeid): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('Amount', amounttext);
    urlParams.append('typeid', typeid);
    urlParams.append('LangId', this._LocalizationService.LANGID.toString());
    urlParams.append('langCode', this._LocalizationService.LANGCODE.toString());

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('/API/DepositPaysafeCard', body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  depositNeteller(amounttext, typeid): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('Amount', amounttext);
    urlParams.append('typeid', typeid);
    urlParams.append('LangId', this._LocalizationService.LANGID.toString());
    urlParams.append('langCode', this._LocalizationService.LANGCODE.toString());

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('/API/DepositNeteller', body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  depositOnlineUeber(amounttext): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('Amount', amounttext);
    urlParams.append('LangId', this._LocalizationService.LANGID.toString());
    urlParams.append('langCode', this._LocalizationService.LANGCODE.toString());

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('API/DepositUeber', body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  depositPaypal(amounttext): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('Amount', amounttext);
    urlParams.append('LangId', this._LocalizationService.LANGID.toString());
    urlParams.append('langCode', this._LocalizationService.LANGCODE.toString());

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('API/DepositPaypal', body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  depositSofort(amounttext): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('Amount', amounttext);
    urlParams.append('LangId', this._LocalizationService.LANGID.toString());
    urlParams.append('langCode', this._LocalizationService.LANGCODE.toString());

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('API/PaymentGatewaySofort', body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  withdrawCoinBase(coinbaseDataRaw): Promise<any> {
    const urlParams = new URLSearchParams();

    urlParams.append('withdrawamount', coinbaseDataRaw.withdrawamount);
    urlParams.append('bitcoinAddress', coinbaseDataRaw.bitcoinAddress);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getBitcoinWithdrawUrl, body, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);
    this._UiHelper.setLoadingDialog(false);
  }

  withdrawMuchBetter(coinbaseDataRaw): Promise<any> {
    const urlParams = new URLSearchParams();

    urlParams.append('withdrawamount', coinbaseDataRaw.withdrawamount);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post('/API/WithdrawMuchbetter', body, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);

    this._UiHelper.setLoadingDialog(false);
  }
  generalWithdraw(formDataRaw): Promise<any> {
    const urlParams = new URLSearchParams();

    urlParams.append('withdrawamount', formDataRaw.withdrawamount);
    urlParams.append('transactionType', formDataRaw.transactionTypeId);

    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('accountId', formDataRaw.phoneNumber || formDataRaw.mailadress);

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post('/API/GeneralWithdraw', body, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);

    this._UiHelper.setLoadingDialog(false);
  }
  withdrawApco(amount, typeid, accountId): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('amount', amount);
    urlParams.append('transactionType', typeid);
    urlParams.append('accountId', accountId);
    urlParams.append('LangId', this._LocalizationService.LANGID.toString());
    urlParams.append('langCode', this._LocalizationService.LANGCODE.toString());

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('/API/WithdrawApco', body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  withdrawPaypal(coinbaseDataRaw): Promise<any> {
    const urlParams = new URLSearchParams();

    urlParams.append('withdrawamount', coinbaseDataRaw.withdrawamount);
    urlParams.append('paypaladdress', coinbaseDataRaw.paypaladdress);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post('/API/WithdrawPaypal', body, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);

    this._UiHelper.setLoadingDialog(false);
  }

  getWithdrawBanks(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getWithdrawBanksUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(this.handleError);
  }

  withdrawBanks(banksDatasRaw, bankId): Promise<any> {
    const urlParams = new URLSearchParams();

    urlParams.append('bankId', bankId);
    urlParams.append('accountNo', banksDatasRaw.accountNo);
    urlParams.append('ssn', banksDatasRaw.ssn);
    urlParams.append('nameSurname', banksDatasRaw.nameSurname);
    urlParams.append('withdrawamount', banksDatasRaw.banksAmount);

    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getBanksWithdrawUrl, body, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);
  }

  withdrawBanks4fa(banksDatasRaw): Promise<any> {
    const urlParams = new URLSearchParams();

    urlParams.append('bankId', '1');
    urlParams.append('accountNo', banksDatasRaw.accountNo);
    urlParams.append('ssn', banksDatasRaw.ssn);
    urlParams.append('nameSurname', banksDatasRaw.bankList + banksDatasRaw.nameSurname);
    urlParams.append('withdrawamount', banksDatasRaw.banksAmount);

    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getBanksWithdrawUrl, body, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);
  }

  getOutrightSports(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getOutrightSportsUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
  }

  getOutrightCategories(sportId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getOutrightCategoriesUrl}/${sportId}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
    this._UiHelper.setLoadingDialog(false);
  }

  getOutrightEvents(categoryId, sportId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getOutrightEventsUrl}/${categoryId}/${sportId}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
    this._UiHelper.setLoadingDialog(false);
  }

  getOutrightMatch(matchId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getOutrightMatchUrl}/${matchId}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(this.handleError);
  }

  getOutrightMatchOdds(matchId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getOutrightMatchOddsUrl}/${matchId}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
  }

  // getOutrightMatchOddsbyTourIdUrl
  getOutrightMatchOddsbyTourId(matchId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getOutrightMatchOddsbyTourIdUrl}/${matchId}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
  }

  addOutrightsOdd(oddId): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('OddId', oddId);
    urlParams.append('BetType', '2');
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const slipstring = JSON.stringify(this.slipCurrents);
    localStorage.setItem('currentslip', slipstring);
    urlParams.append('currentslip', slipstring);
    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.addOddUrl, body, { headers })
      .toPromise()
      .then((response: any) => {
        this.slipCurrents = response;
        const slipstring = JSON.stringify(this.slipCurrents);
        localStorage.setItem('currentslip', slipstring);

        this.getSelectedOdds();
        // comp.getSelectedOdds();
        this.getCurrentSlip();
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getResultSports(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getResultSportsUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
    this._UiHelper.setLoadingDialog(false);
  }

  getResultCategories(sportId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getResultCategoriesUrl}/${sportId}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
    this._UiHelper.setLoadingDialog(false);
  }

  getTournamentsByCategoryId(categoryId, sportId, dayFilter): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getTournamentsByCategoryIdUrl}/${sportId}/${categoryId}/${this._LocalizationService.LANGID}/${dayFilter}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
    this._UiHelper.setLoadingDialog(false);
  }

  getResultsList(categoryId, sportId, tournamentId, tournamentName, pageNo): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getResultsUrl}/${sportId}/${categoryId}/${tournamentId}/${tournamentName}/${pageNo}/${this._LocalizationService.LANGID}/${this._LocalizationService.TIMEZONE}`, {
        headers,
      })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
    this._UiHelper.setLoadingDialog(false);
  }

  getCustomerTicket(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getGetCustomerTicketUrl}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
    this._UiHelper.setLoadingDialog(false);
  }

  getCustomerTicketDetail(ticketId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getCustomerTicketDetailUrl}/${ticketId}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
    this._UiHelper.setLoadingDialog(false);
  }

  AnswerTicketMessage(ticketDatas, FilePath, Subject): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('TicketId', ticketDatas.TicketId);
    urlParams.append('Subject', Subject);
    urlParams.append('Message', ticketDatas.Message);
    urlParams.append('FilePath', FilePath);
    urlParams.append('ActivityCode', ticketDatas.ActivityCode);
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getAnswerTicketMessageUrl, body, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);

    this._UiHelper.setLoadingDialog(false);
  }

  UploadtoAWS(file, subpath): Promise<any> {
    const formData = new FormData();
    formData.append('__RequestVerificationToken', this.antiForgeryToken.toString());
    formData.append('subpath', subpath);
    formData.append('file', file);

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken);
    // .set('Content-Type', 'application/json');

    return this.http
      .post(this.getUploadtoAWSUrl, formData, { headers })

      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return { ...responseData, name: file.name };
      })
      .catch(() => {
        this._UiHelper.setLoadingDialog(false);
        return this.handleError;
      });
  }

  UploadtoAWSFromSupport(file, subpath): Promise<any> {
    const formData = new FormData();
    formData.append('__RequestVerificationToken', this.antiForgeryToken.toString());
    formData.append('subpath', subpath);
    formData.append('file', file);

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken);
    // .set('Content-Type', 'application/json');

    return this.http
      .post(this.getUploadtoAWSFromSupportUrl, formData, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);

    this._UiHelper.setLoadingDialog(false);
  }

  getCustomerOne(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getGetCustomerOneUrl}`, { headers })
      .toPromise()
      .then(response => {
        /* this._UiHelper.setLoadingDialog(false);*/
        return response;
      })
      .catch(err => {
        const translator = new TranslatePipe(this._LocalizationService);
        const t_message = translator.transform('errorcode5', null);
        this._UiHelper.errorSnackBar(t_message, '');
        return '';
      });
    /*this._UiHelper.setLoadingDialog(false);*/
  }

  getComboPhoneNumberList(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.getComboPhoneNumberUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getComboPasswordQuestionList(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.getComboPasswordQuestionUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  saveCustomerDetail(data): Promise<any> {
    ////// console.log("this.userprofileDataRaw", data);
    const urlParams = new URLSearchParams();
    urlParams.append('customerName', data.CustomerName);
    urlParams.append('customerSurname', data.CustomerSurname);
    urlParams.append('address', data.Address || '');
    urlParams.append('addressAdditional', data.AddressAdditional);
    urlParams.append('city', data.City);
    urlParams.append('countryId', data.CountryId);
    urlParams.append('eMail', data.Email);
    urlParams.append('phoneNumber', data.PhoneNumber);
    urlParams.append('phoneCodeId', data.PhoneCodeId);
    urlParams.append('passwordQuestion', '');
    urlParams.append('passwordQuestionId', data.PasswordQuestionId);
    urlParams.append('passwordQuestion', data.PasswordAnswer);

    urlParams.append('oddchangehigher', data.IsOddIncreasement);
    urlParams.append('oddchangelower', data.IsOddDecreasements);
    urlParams.append('idnumber', data.IdNumber);
    urlParams.append('passportnumber', data.PassportNo);
    urlParams.append('birthplace', data.BirthPlace);
    urlParams.append('taxno', data.TaxNo);
    urlParams.append('promotionPermission', data.PromotionPermission);
    urlParams.append('birthday', data.Birthday);
    urlParams.append('housenumber', data.OddsFormatId);
    urlParams.append('zip', data.ZipCode);

    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('timeZone', this._LocalizationService.TIMEZONE.toString());
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getSaveCustomerDetailUrl, body, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);

    this._UiHelper.setLoadingDialog(false);
  }

  cloudFiles(data, a): Promise<any> {
    /*////console.log("RESiM", data);*/
    const urlParams = new URLSearchParams();
    urlParams.append('DocumentId', data.DocumentTypeCombo);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('Link', a);
    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getCloudFilesUrl, body, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return response;
      })
      .catch(this.handleError);

    this._UiHelper.setLoadingDialog(false);
  }

  getUploadFilesControl(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getUploaddocControl}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
  }

  getUnreadMessage(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getUnreadMessageUrl}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(err => {
        console.error(err);
      });
  }

  getPages(pageId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getPagesUrl}/${pageId}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
  }

  getPagesbyName(pageTitle): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getPagebyTitleUrl}/${pageTitle}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(this.handleError);
  }

  getSearch4Favs(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    //// console.log("favs", this._UserHelper.favoriedMatches);
    // fav filter
    let _favs = '';
    if (this._UserHelper.favoriedMatches != undefined && this._UserHelper.favoriedMatches.length > 0) {
      this._UserHelper.favoriedMatches.forEach(event => {
        _favs += event + ',';
      });
    } else {
      _favs = '0';
    }
    // fav filter

    return this.http
      .get(`${this.getSearch4FavsUrl}/${_favs}/${this._LocalizationService.LANGID}/${this._LocalizationService.TIMEZONE}`)
      .toPromise()
      .then(r => {
        //// console.log(r);
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  mailConfirm(confirmkey, langId): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('confirmkey', confirmkey);
    urlParams.append('langId', langId);
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getMailConfirmUrl, body, { headers })
      .toPromise()
      .then(response => {
        /*this._UiHelper.setLoadingDialog(false);*/

        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);

    /*this._UiHelper.setLoadingDialog(false);*/
  }

  recoverPassword(recoverPasswordDatas: any, recoverykey, langId): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('recoverykey', recoverykey);
    urlParams.append('changenewpassword', recoverPasswordDatas.newPassword);
    urlParams.append('changenewrepassword', recoverPasswordDatas.reNewPassword);
    urlParams.append('langId', langId);
    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.recoverPasswordUrl, body, { headers })
      .toPromise()
      .then(response => {
        ////// console.log(response);
        let responseData: any;
        responseData = JSON.parse(response as string);
        ////// console.log(responseData);
        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  refreshAuthToken(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'text/html');
    const options = { headers, responseType: 'text' as const };
    return this.http
      .get(`/Login/Refresh/`, options)
      .toPromise()
      .then(r => {
        document.getElementById('cont_antiforgerytoken').innerHTML = r;
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getLiveCasinoGames(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`/API/LiveCasinoGames`, { headers })
      .toPromise()
      .then(r => {
        //// console.log("Live Casino Games", r);
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  openLiveCasinoGame(company: string, id: number, limitId: number): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`/API/LiveCasinoOpenGame/` + company + `/` + id.toString() + `/test/` + limitId, { headers })
      .toPromise()
      .then(r => {
        //// console.log("Live Casino Games URL", r);
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getLinkVirtualGoldenRace(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`/API/VirtualGoldenRace/`, { headers })
      .toPromise()
      .then(r => {
        //// console.log("VIRTUAL GOLDEN RACE URL", r);
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getCasinoRiseUpGames(productName: string): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`API/CasinoRiseUpGames/` + productName, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getCasinoRiseUpGameUrl(productName: string, gameId: string, mode: string, device: string): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`API/CasinoRiseUpGameUrl/` + productName + '/' + gameId + '/' + mode + '/' + device + '/' + this._LocalizationService.LANGCODE, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getScannerSlipDetail(_slipId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getScannerSlipDetailUrl}/${this._LocalizationService.LANGID}/${_slipId}/${this._LocalizationService.TIMEZONE}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        const translator = new TranslatePipe(this._LocalizationService);
        const t_message = translator.transform('errorcode5', null);
        this._UiHelper.errorSnackBar(t_message, '');
        return '';
      });
  }

  getScannerSlipOneBySlipId(_slipId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getScannerSlipOneBySlipIdUrl}/${this._LocalizationService.LANGID}/${_slipId}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return '';
      });
  }

  slipRestore(slipId): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('slipId', slipId);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.slipRestoreUrl, body, { headers })
      .toPromise()
      .then((response: any) => {
        this.slipCurrents = response;
        const slipstring = JSON.stringify(this.slipCurrents);
        localStorage.setItem('currentslip', slipstring);

        this.getSelectedOdds();

        this.getCurrentSlip();
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getInsicToken(): Promise<any> {
    const urlParams = new URLSearchParams();

    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post('/API/InsicToken', body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);

        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getInsicSOWToken(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get('/API/InsicSOWToken', { headers })
      .toPromise()
      .then(response => {
        ////// console.log(r);
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getInsicStatus(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get('/API/InsicStatus2/' + this._UserHelper.customerUser.UserName, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  helpMail(userName, email, category, problem, message): Promise<any> {
    const translator = new TranslatePipe(this._LocalizationService);
    const error_message = translator.transform('help_mail_error', null);
    const success_message = translator.transform('help_mail_success', null);

    const urlParams = new URLSearchParams();
    // urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    // urlParams.append('userName', userName);
    // urlParams.append('email', email);
    // urlParams.append('category', category);
    // urlParams.append('problem', problem);
    // urlParams.append('message', message);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };

    return this.http
      .post(`${this.helpMailUrl}/${userName}/${email}/${category}/${problem}/${message}`, body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        if (responseData == 'success') {
          this._UiHelper.successSnackBar(success_message, '');
        } else if (responseData == 'error') {
          this._UiHelper.errorSnackBar(error_message, '');
        }
        return response;
      })
      .catch(error => {
        this._UiHelper.setLoadingDialog(false);
        this._UiHelper.errorSnackBar(error_message, '');
        return this.handleError(error);
      });
  }

  CasinoControl(CustomerId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.CasinoControlUrl}/${CustomerId}`, { headers })
      .toPromise()
      .then(response => {
        ////// console.log(r);
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  AWSGetImage(imageLink): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('imageLink', imageLink);

    const body = urlParams.toString();
    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    const options = { headers, responseType: 'text' as const };
    return this.http
      .post(this.AWSGetImageUrl, body, options)
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        return response;
      })
      .catch(error => {
        this._UiHelper.setLoadingDialog(false);
        return this.handleError(error);
      });
  }

  getWithDrawDepositControl3(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getWithDrawDepositControl3Url}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getAllDepositControl3(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getAllDepositControl3Url}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  bookingLoginResult(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.bookingLoginResultUrl}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  CasinoGameCreateToken(sessionId): Promise<any> {
    this._UiHelper.setLoadingDialog(true);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`/Casino/CreateGameToken/` + sessionId, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);
  }

  getDigitalCard(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.digitalCardUrl}`, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  procCustomerQrCodeResult(BranchId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.procCustomerQrCodeResultUrl}/${BranchId}`, { headers })
      .toPromise()
      .then(response => {
        ////// console.log(r);
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  accountLock24(): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('lockDayCount', '1');
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getAccountLockUrl, body, { headers })
      .toPromise()
      .then(response => {
        let responseData: any;
        responseData = JSON.parse(response as string);

        return responseData;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getProcAccountLockDayResult(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.procAccountLockDayResultUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        ////// console.log(r);
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getProcCustomerAccountLockNewResult(LockDayCount: number, LockDayReason: number): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.procCustomerAccountLockNewResultUrl}/${LockDayCount}/${LockDayReason}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        ////// console.log(r);
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getProcAccountLockReasonResult(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.procAccountLockReasonResultUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(response => {
        ////// console.log(r);
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  withdrawAutoMuchBetter(coinbaseDataRaw, isActive = true): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('withdrawamount', coinbaseDataRaw.withdrawamount);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('isActive', isActive.toString());
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    const body = urlParams.toString();
    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http
      .post(this.getWithdrawAutoMuchbetterUrl, body, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);

    this._UiHelper.setLoadingDialog(false);
  }

  withdrawAutoBanks(banksDatasRaw, bankId, isActive = true): Promise<any> {
    const urlParams = new URLSearchParams();

    urlParams.append('bankId', bankId);
    urlParams.append('accountNo', banksDatasRaw.accountNo);
    urlParams.append('ssn', banksDatasRaw.ssn);
    urlParams.append('nameSurname', banksDatasRaw.nameSurname);
    urlParams.append('withdrawamount', banksDatasRaw.banksAmount);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('isActive', isActive.toString());
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getWithdrawAutoBanksUrl, body, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);
  }

  withdrawAutoPaypal(coinbaseDataRaw, isActive = true): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('withdrawamount', coinbaseDataRaw.withdrawamount);
    urlParams.append('paypaladdress', coinbaseDataRaw.paypaladdress);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());
    urlParams.append('isActive', isActive.toString());
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post(this.getWithdrawAutoPaypalUrl, body, { headers })
      .toPromise()
      .then(response => {
        this._UiHelper.setLoadingDialog(false);
        let responseData: any;
        responseData = JSON.parse(response as string);
        return responseData;
      })
      .catch(this.handleError);

    this._UiHelper.setLoadingDialog(false);
  }

  getProcCustomerWithDrawRequestScreenResult(TransactionType): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getProcCustomerWithDrawRequestScreenResultUrl}/${TransactionType}`, { headers })
      .toPromise()
      .then(response => {
        ////// console.log(r);
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getProcCustomerBonusTrackerResult(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getProcCustomerBonusTrackerResultUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getProcCustomerBonusOnlineTracker1Result(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getProcCustomerBonusOnlineTracker1ResultUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getProcCustomerBonusTracker1Result(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getProcCustomerBonusTracker1ResultUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getProcTournamentTopResult(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getProcTournamentTopResultUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getProcCustomerContract(IsContractAccepted: boolean): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.ProcCustomerContractUrl}/${IsContractAccepted}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getProcCustomerIBANUIDResult(customerId, Iban): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getProcCustomerIBANUIDResultUrl}/${customerId}/${Iban}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  getBranchAddress(terminalId): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getBranchAddressUrl}/${terminalId}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  restoreSlip(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.restoreSlipUrl}`, { headers })
      .toPromise()
      .then((r: any) => {
        this.slipCurrents = r;
        const slipstring = JSON.stringify(this.slipCurrents);
        localStorage.setItem('currentslip', slipstring);

        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getQuickRegisterInfo(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getQuickRegisterUrl}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getTournamentStatistic(tournamentID: number): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`https://api.canlimac.com.tr/getLeagueLastSeasonStats/${tournamentID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getTournamentStatisticB3000(sportId: number, categoryId: number, tournamentID: number): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.ProcMatchStandingResult}/${sportId}/${categoryId}/${tournamentID}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  checkPassword(password: any): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);

    urlParams.append('password', password);
    urlParams.append('langId', this._LocalizationService.LANGID.toString());

    const body = urlParams.toString();

    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');

    // this.checkOnlineStatus();
    return this.http
      .post(this.postPasswordControl, body, { headers })
      .toPromise()
      .then(response => {
        //// console.log(response);

        //// console.log(responseData);
        // this.configureClient();
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getSearchB3000(q): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    q = q.replace(' ', '+');

    return this.http
      .get(`${this.getSearchB3000Url}/${q}/${this._LocalizationService.LANGID}/${this._LocalizationService.TIMEZONE}`)
      .toPromise()
      .then(r => {
        //// console.log(r);
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getTransactionHistory(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.getTransactionHistoryUrl}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getResendConfirmationMail(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.getResendConfirmationMailUrl}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  loadSavedSlip() {
    // const sliptext = localStorage.getItem('currentslip');
    // if (sliptext != undefined && sliptext != '' && sliptext != 'null') {
    //  this.slipCurrents = JSON.parse(sliptext);
    //  this.getCurrentSlip();
    // }
    // else {
    //  this.slipCurrents = [];
    // }
  }

  getOddComparison(): Promise<any> {
    const urlParams = new URLSearchParams();

    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.getOddComparisonUrl}?langId=${this._LocalizationService.LANGID.toString()}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  signalrConnection(state: boolean): void {
    if (state) {
      this._SignalrServiceLegacy.startConnection();
      this._SignalrServiceLegacy.signalRTimer();
      return;
    }
    this._SignalrServiceLegacy.stopConnection();
    this._SignalrServiceLegacy.disposeSignalRTimer();

    return;
  }
  getSliderWeb(v: string): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.sliderWebUrl}/${this._LocalizationService.LANGID}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  autoWithdrawReq(IsActive: boolean, Withdrawlimit: number): Promise<any> {
    const urlParams = new URLSearchParams();
    urlParams.append('__RequestVerificationToken', this.antiForgeryToken);
    urlParams.append('IsActive', IsActive.toString());
    urlParams.append('Withdrawlimit', Withdrawlimit.toString());
    const body = urlParams.toString();
    const headers = new HttpHeaders().set('Authorization', this.antiForgeryToken).set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http
      .post(this.AutoWithdrawAutoReqUrl, body, { headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  realityCheckProvider(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.RealityCheckProviderUrl}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  timeOut(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.timeOutURL}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  realityCheckPlayer(activityExpired: boolean): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(`${this.RealityCheckPlayerUrl}/${activityExpired}`, { headers })
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }
  getCustomerFinSchufa(): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .get(`${this.getProcCustomerStatusRequestResultUrl}`)
      .toPromise()
      .then(r => {
        return r;
      })
      .catch(e => {
        if (e.status == 401) {
          return false;
        }
      });
  }

  /*
EN ALTTA KALMALI
 */

  handleError(error: any): Promise<any> {
    // console.error('An error occurred', error);
    if (error.status == 401) {
      this._UserHelper.signInListener.emit(false);
      return Promise.reject(error.message || error);
    }
    return Promise.reject(error.message || error);
  }
}
